import { render } from "./TheScheduleUserProfileServiceList.vue?vue&type=template&id=f8303ed2"
import script from "./TheScheduleUserProfileServiceList.vue?vue&type=script&lang=js"
export * from "./TheScheduleUserProfileServiceList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__